import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getWhiteLogoUri } from '#/redux/modules/accedoOne/selectors';
import styles from './tvContentHeader.scss';

export const TV_CONTENT_HEADER = 'TV_CONTENT_HEADER';

export const TVContentHeader = ({ visible = false, title = '' }) => {
  const logoUri = useSelector(getWhiteLogoUri);

  return visible ? (
    <div id={TV_CONTENT_HEADER} className={styles.container}>
      <div className={styles.content}>
        <div className={styles.titleWrap}>
          <div className={styles.title}>{title}</div>
        </div>
        <div className={styles.logoWrap}>
          <img className={styles.logo} src={logoUri} alt="Logo" />
        </div>
      </div>
    </div>
  ) : null;
};
TVContentHeader.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string,
};
